import { z } from 'zod';
export const wishStatus = z.enum(['ACTIVE', 'ARCHIVED', 'COMPLETED', 'DELETED']);
export const imageSource = z.enum(['DEFAULT', 'OG', 'UPLOADED']);
export const wishSchema = z.object({
    id: z.string(),
    title: z.string(),
    price: z.string().nullable(),
    currency: z.string(),
    url: z.string().nullable(),
    comment: z.string().nullable(),
    imageUrl: z.string().nullable(),
    imageSource: imageSource,
    status: wishStatus,
    createdAt: z.string(),
    updatedAt: z.string(),
    archivedAt: z.string().nullable(),
    completedAt: z.string().nullable(),
    deletedAt: z.string().nullable(),
    sourceWishId: z.string().nullable(),
    isNewForGuest: z.boolean().optional(),
});
export const createWishSchema = z.object({
    title: z.string().trim().min(1).max(200),
    price: z
        .union([
        z.string().trim().regex(/^\d+(\.\d{1,2})?$/, 'Price must be a number with up to 2 decimals'),
        z.literal(''),
        z.null(),
    ])
        .optional()
        .transform((v) => (v === '' || v == null ? null : v)),
    currency: z.string().trim().length(3).toUpperCase().default('RUB'),
    url: z
        .union([z.string().trim().url(), z.literal(''), z.null()])
        .optional()
        .transform((v) => (v === '' || v == null ? null : v)),
    comment: z
        .union([z.string().trim().max(2000), z.literal(''), z.null()])
        .optional()
        .transform((v) => (v === '' || v == null ? null : v)),
});
export const updateWishSchema = createWishSchema.partial();
export const wishStatusQuery = z
    .enum(['active', 'archived', 'completed', 'deleted'])
    .default('active');
export const NEW_BADGE_DAYS = 5;
export const TRASH_RETENTION_DAYS = 30;
//# sourceMappingURL=wish.schema.js.map